import type { GameDestinationContext } from "@softmax/web-addresses";
import type { SiteSearchCoworldContext } from "./search/search-input";
import { leavesTheSite } from "./site-links";

export type CoworldNav = {
  readonly name: string;
  readonly coworldName: string;
  readonly corpusSlug: string;
  readonly route: GameDestinationContext;
  readonly wikiPages: number | null;
  readonly forumHref: string;
  readonly docs: {
    readonly title: string;
    readonly href: string;
    readonly matchPrefix?: string;
  } | null;
  readonly playHref: string;
  /** The coworld's square icon, when it has one. */
  readonly icon: string | null;
  readonly links?: { readonly label: string; readonly href: string }[];
};

export function coworldSearchContext(
  coworld: CoworldNav,
): SiteSearchCoworldContext {
  return {
    name: coworld.coworldName,
    corpusSlug: coworld.corpusSlug,
    route: coworld.route,
    hasWiki: coworld.docs !== null && !leavesTheSite(coworld.docs.href),
  };
}

export type CoworldMenuItem = {
  readonly key:
    | "browse"
    | "watch"
    | "play"
    | "forum"
    | "wiki"
    | "policies"
    | "docs";
  readonly label: string;
  readonly href: string;
  readonly matchPrefix?: string;
  readonly external?: boolean;
};

export function coworldMenu(coworld: CoworldNav): CoworldMenuItem[] {
  const items: CoworldMenuItem[] = [
    { key: "play", label: "Play", href: coworld.playHref },
  ];

  if (coworld.docs && !/\/wiki(\/|$)/.test(coworld.docs.href)) {
    items.push({
      key: "docs",
      label: coworld.docs.title,
      href: coworld.docs.href,
      ...("matchPrefix" in coworld.docs && {
        matchPrefix: coworld.docs.matchPrefix,
      }),
      external: leavesTheSite(coworld.docs.href),
    });
  }

  return items;
}
